export const KEYFOB_RADIX = 15;
export const MIN_KEYFOB_LENGTH = 6;
export const MAX_KEYFOB_LENGTH = 7;
export const MAX_KEYFOBS_COUNT_TO_GENERATE = 5000;